import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import API from "../Network/API";
import UserAvatar from "./UserAvatar";
import { flagUrl, teacherPath } from "../services/Helper";

// "You might also like" strip on the teacher profile: teachers sharing a
// course category, topped up with random teachers by the API.
export default function RelatedTeachers({ slug }) {
    const { t } = useTranslation();
    const location = useLocation();
    const prefix = location.pathname.startsWith("/app") ? "/app" : "";
    const [teachers, setTeachers] = useState([]);

    useEffect(() => {
        if (!slug) return;
        API.get(`/v1/oauth/teacher/${slug}/related`)
            .then((response) => setTeachers(response.data.data || []))
            .catch(() => setTeachers([]));
    }, [slug]);

    if (teachers.length === 0) return null;

    return (
        <section className="related-tutors">
            <h2 className="related-tutors-title">{t("relatedTeachers.title")}</h2>
            <div className="related-tutors-grid">
                {teachers.map((teacher) => {
                    const rating = Number(teacher?.ratings_avg_rating || 0);
                    return (
                        <Link key={teacher.id} to={teacherPath(teacher, prefix)} className="related-tutor">
                            <div className="related-tutor-photo">
                                <UserAvatar src={teacher?.avatar} name={teacher?.name} size={320} />
                                <div className="related-tutor-caption">
                                    <span>{teacher?.name}</span>
                                    {teacher?.country_code &&
                                        <img src={flagUrl(teacher.country_code)} alt={teacher?.country_name || teacher.country_code}
                                             onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                                    }
                                </div>
                            </div>
                            <div className="related-tutor-rating">
                                <i className="fa-solid fa-star" />
                                {rating > 0 ? rating.toFixed(1) : t("teacherProps.new")}
                                <span>({teacher?.ratings_count || 0})</span>
                            </div>
                            {teacher?.teacher_info?.bio &&
                                <p className="related-tutor-headline">{teacher.teacher_info.bio}</p>
                            }
                            <p className="related-tutor-price">
                                <strong>USD {teacher?.lesson_price}</strong> <span>{t("relatedTeachers.per_lesson")}</span>
                            </p>
                        </Link>
                    );
                })}
            </div>
        </section>
    );
}
